import React from 'react';
import { ShieldCheck, Award, Globe2, BadgeCheck } from 'lucide-react';

const CLIENTS = ['FinNova', 'MediLink Health', 'ZenPay', 'RouteHive', 'LearnSphere', 'HavenHub', 'SteelCore', 'ForkFast', 'Wanderly', 'AgroBridge', 'DriveSphere', 'Lumière'];

const BADGES = [
  { Icon: ShieldCheck, label: 'ISO/IEC 27001:2022 Certified' },
  { Icon: BadgeCheck, label: 'GDPR-Ready Delivery' },
  { Icon: Award, label: '1000+ Projects Since 2015' },
  { Icon: Globe2, label: '9 Offices · 3 Continents' },
];

const TrustBar = () => (
  <section className="bg-slate-950 border-t border-white/5 py-10 overflow-hidden" data-testid="trust-bar">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="text-center text-[11px] font-semibold uppercase tracking-[0.25em] text-slate-500">Trusted by growing companies worldwide</div>
      <div className="relative mt-6">
        <div className="flex gap-12 whitespace-nowrap animate-[marquee_35s_linear_infinite] hover:[animation-play-state:paused]" style={{ width: 'max-content' }}>
          {[...CLIENTS, ...CLIENTS].map((c, i) => (
            <span key={i} className="text-lg font-extrabold tracking-tight text-slate-500/80 hover:text-white transition-colors select-none">{c}</span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-slate-950 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-slate-950 to-transparent" />
      </div>
      <div className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3">
        {BADGES.map(({ Icon, label }) => (
          <div key={label} className="flex items-center gap-2 text-xs font-semibold text-slate-300">
            <Icon className="h-4 w-4 text-orange-400" /> {label}
          </div>
        ))}
      </div>
    </div>
    <style>{`@keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
  </section>
);

export default TrustBar;
